import React from 'react'

import {fromPairs} from 'lodash'

import {DropdownSelect} from '@festi/common/components/form'

import {useAlgoliaContext} from '../context/AlgoliaContext'

export interface Option {
  value: number
  label: string
}

export const resultsOptions: Option[] = [
  {value: 24, label: '24 vörur á síðu'},
  {value: 48, label: '48 vörur á síðu'},
  {value: 96, label: '96 vörur á síðu'},
]

export default function SelectSize() {
  const {hitsPerPage, setHitsPerPage} = useAlgoliaContext()

  const resultsOptionsMap = fromPairs(resultsOptions.map((o) => [o.value, o]))

  return (
    <DropdownSelect
      label="Fjöldi vara á síðu"
      items={resultsOptions}
      defaultValue={hitsPerPage.toString()}
      onValueChange={(value) => {
        setHitsPerPage(resultsOptionsMap[value].value)
      }}
    >
      {hitsPerPage}
    </DropdownSelect>
  )
}
